import React, { useMemo } from 'react';
import { DisclaimerInfo } from 'QuoteApp/components/DisclaimerInfo';
import { useAppAvailableProducts } from 'QuoteApp/services/providers';
import { renderOperatingCompany } from 'Shared/utils/formatters';

export const SummaryDisclaimer = () => {
  const availableProducts = useAppAvailableProducts();

  const disclaimer = useMemo(() => {
    if (!availableProducts) return null;

    const companies = availableProducts
      .map(renderOperatingCompany)
      .join(' or ');

    return `Insurance products are underwritten by ${companies}.`;
  }, [availableProducts]);

  return disclaimer ? <DisclaimerInfo text={disclaimer} /> : null;
};
